import {applyMiddleware, combineReducers, createStore} from 'redux'
import {connectRoutes} from 'redux-first-router/dist'
import {composeWithDevTools} from 'redux-devtools-extension'
import {routes} from './routes'
import * as querySerializer from './querySerializer'
import analytics from './helpers/analytics'
import {createGame} from './reducers/createGame'

const {reducer: location, middleware, enhancer} = connectRoutes(routes, {
  querySerializer,
})

export const store = createStore(
  combineReducers({location, createGame}),
  composeWithDevTools(
    enhancer,
    applyMiddleware(middleware),
    applyMiddleware(analytics),
  ),
)